import { queryClient } from '@/lib/tanstack-query';
import { getGroupQueryOptions } from '@/features/groups/api/get-group';
import { GroupStatus } from '@/types/api/group';
import { paths } from '@/config/paths';

export async function resolveGroupEntryPath(groupId: string): Promise<string> {
  const group = await queryClient.fetchQuery(getGroupQueryOptions(groupId));

  if (group.status === GroupStatus.Onboarding) return paths.group.onboarding.getHref();
  if (!group.defaultSaleId) return paths.sales.create.getHref();

  return paths.sale.overview.getHref(group.defaultSaleId);
}
